<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="商品明細"
    top="5vh"
    :visible.sync="dialogVisible"
    append-to-body
    @close="close"
  >
    <div class="dialog-main-div">
      <vab-query-form
        :model="queryForm"
        :enable-query-save="false"
        size="mini"
        label-position="right"
        label-width="160px"
        @search="onSearch"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item label="商品">
              <div style="display: flex">
                <el-col :span="6">
                  <el-input
                    v-if="goodslists.length == 1"
                    v-model="goodslists[0].code"
                    disabled
                  />
                  <el-input
                    v-else-if="goodslists.length > 1"
                    value="<複数>"
                    disabled
                  />
                  <el-input v-else value="" disabled />
                </el-col>
                <el-col :span="16" style="margin-left: 20px">
                  <el-input
                    v-if="goodslists.length == 1"
                    v-model="goodslists[0].title"
                    disabled
                  />
                  <el-input
                    v-else-if="goodslists.length > 1"
                    value="<複数>"
                    disabled
                  />
                  <el-input v-else value="" disabled />
                </el-col>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-popover
              v-show="goodslists.length > 1"
              placement="bottom"
              trigger="click"
            >
              <el-table :data="goodslists" border stripe>
                <el-table-column
                  width="80"
                  property="code"
                  label="商品CD"
                ></el-table-column>
                <el-table-column
                  width="120"
                  property="title"
                  label="商品名"
                ></el-table-column>
              </el-table>
              <el-button
                slot="reference"
                size="mini"
                type="primary"
                icon="el-icon-more"
                style="margin-top: 10px"
              ></el-button>
            </el-popover>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="商品明細名CD">
              <el-input v-model="queryForm.code" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="商品明細名(半角ｶﾅ)">
              <el-input v-model="queryForm.title" />
            </el-form-item>
          </el-col>
        </el-row>
      </vab-query-form>
      <el-row class="vab-list-body">
        <el-col :span="24">
          <vab-table
            ref="table"
            api-url="/goodDetails/list"
            :columns="columns"
            :custom-config="false"
            :multi-select="multiSelect"
            height="300"
            :query-params.sync="queryForm"
            @selection-change="setSelectRows"
          />
        </el-col>
      </el-row>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save()">確定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'GoodDetailDialog',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      goodslists: {
        type: Array,
        default: () => [],
      },
      multiSelect: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        dialogVisible: false,
        selectRows: [],
        callback: {
          type: Function,
          default: null,
        },
        queryForm: {
          code: null,
          title: null,
          goodcodes: null,
        },
        columns: [
          {
            label: '商品明細CD',
            'min-width': 80,
            prop: 'code',
          },
          {
            label: '商品明細名',
            'min-width': 120,
            prop: 'title',
          },
        ],
      }
    },
    watch: {
      visible: function (val) {
        this.dialogVisible = val
      },
    },
    methods: {
      close() {
        this.dialogVisible = false
        this.$emit('update:visible', false)
      },
      save() {
        this.close()
        this.$emit('get-selection', {
          data: this.selectRows,
          filedCode: 'code',
          filedVal: 'title',
        })
      },
      setSelectRows(val) {
        this.selectRows = val
        if (this.callback) {
          this.callback(val)
        }
      },
      onSearch() {
        this.$refs.table.fetchData()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .el-form-item {
    .el-form-item__label {
      .el-button {
        width: 100%;
      }
    }
    .multiple {
      ::v-deep {
        .el-input__inner {
          text-align: center !important;
        }
      }
    }
  }
</style>
